import { render, staticRenderFns } from "./index.vue?vue&type=template&id=135f9aba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=135f9aba&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=135f9aba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f9aba",
  null
  
)

export default component.exports